import React from "react";
import { apiUrl } from "../lib/apiBase";
import { getAuthToken } from "../lib/auth";

export default function NotificationAdmin() {
  const [form, setForm] = React.useState({
    category: "announcement",
    title: "",
    body: "",
    href: "/",
  });
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");

  const update = (key) => (event) => setForm((current) => ({ ...current, [key]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    if (!window.confirm("Send this phone and site notification to all GAStreaming users?")) return;
    setBusy(true);
    setMessage("");
    setError("");
    try {
      const response = await fetch(apiUrl("/push/admin/announcement"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getAuthToken()}` },
        body: JSON.stringify(form),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data?.message || data?.error || "Could not send notification.");

      const push = data?.push || {};
      const android = push?.platforms?.android || {};
      const ios = push?.platforms?.ios || {};
      const errorDetails = Array.isArray(push?.errors) ? push.errors : [];
      const diagnostic = [
        `Sent to ${Number(data?.recipients || 0)} accounts.`,
        `Registered phones: ${Number(push?.devices || 0)}.`,
        `Delivered: ${Number(push?.sent || 0)}.`,
        `Failed: ${Number(push?.failed || 0)}.`,
        `Skipped: ${Number(push?.skipped || 0)}.`,
        `Android ${Number(android?.sent || 0)}/${Number(android?.devices || 0)} delivered.`,
        `iPhone ${Number(ios?.sent || 0)}/${Number(ios?.devices || 0)} delivered.`,
      ];
      if (errorDetails.length) {
        diagnostic.push(
          `Delivery issue: ${errorDetails
            .slice(0, 3)
            .map((item) => `${item?.platform || "phone"}: ${item?.code || item?.error || item?.skipped || "unknown error"}`)
            .join(" | ")}`
        );
      }
      setMessage(diagnostic.join(" "));
      setForm((current) => ({ ...current, title: "", body: "" }));
    } catch (err) {
      setError(err?.message === "founder_only" ? "Only the GAStreaming founder can send community alerts." : err?.message || "Could not send notification.");
    } finally {
      setBusy(false);
    }
  };

  const field = {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,.16)",
    background: "rgba(0,0,0,.38)",
    color: "white",
    padding: "11px 12px",
    outline: "none",
  };

  return (
    <main style={{ maxWidth: 720, margin: "0 auto", padding: "22px 14px 90px" }}>
      <form
        onSubmit={submit}
        style={{
          borderRadius: 20,
          padding: 20,
          color: "white",
          border: "1px solid rgba(255,255,255,.14)",
          background: "rgba(8,10,16,.84)",
          boxShadow: "0 18px 70px rgba(0,0,0,.4)",
        }}
      >
        <h1 style={{ margin: 0, fontSize: 24 }}>GAStreaming Notification Center</h1>
        <p style={{ opacity: 0.78, lineHeight: 1.5 }}>
          Send a site-bell notification and phone alert for a new feature, tournament, or important platform update.
        </p>

        <label style={{ display: "grid", gap: 6, marginTop: 16 }}>
          <strong>Alert type</strong>
          <select value={form.category} onChange={update("category")} style={field}>
            <option value="announcement">Feature / GAStreaming update</option>
            <option value="tournament">Tournament announcement</option>
          </select>
        </label>
        <label style={{ display: "grid", gap: 6, marginTop: 14 }}>
          <strong>Title</strong>
          <input value={form.title} onChange={update("title")} maxLength={100} required style={field} placeholder="New GAStreaming Feature" />
        </label>
        <label style={{ display: "grid", gap: 6, marginTop: 14 }}>
          <strong>Message</strong>
          <textarea value={form.body} onChange={update("body")} maxLength={500} required rows={5} style={{ ...field, resize: "vertical" }} placeholder="Tell the community what is new." />
        </label>
        <label style={{ display: "grid", gap: 6, marginTop: 14 }}>
          <strong>Page to open when tapped</strong>
          <input value={form.href} onChange={update("href")} maxLength={300} required style={field} placeholder="/tournaments" />
          <span style={{ opacity: 0.66, fontSize: 12 }}>Use a GAStreaming path such as /tournaments, /feed, /patches, or /channels.</span>
        </label>

        {error ? <div style={{ marginTop: 14, color: "#ff9eaf" }}>{error}</div> : null}
        {message ? <div style={{ marginTop: 14, color: "#7fffc6", lineHeight: 1.5 }}>{message}</div> : null}
        <button
          type="submit"
          disabled={busy || !form.title.trim() || !form.body.trim()}
          style={{
            marginTop: 18,
            width: "100%",
            border: 0,
            borderRadius: 14,
            padding: "13px 16px",
            color: "white",
            background: "linear-gradient(135deg, #ff1744, #b00020)",
            fontWeight: 950,
            cursor: busy ? "wait" : "pointer",
          }}
        >
          {busy ? "Sending…" : "Send to GAStreaming users"}
        </button>
      </form>
    </main>
  );
}
